import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { HStack } from "@/components/ui/hstack";
import { Input, InputField } from "@/components/ui/input";
import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import i18n from "i18n-js";
import { backendRequest } from '@/stores/thunks';
import * as Sentry from '@sentry/react-native';
import { switchScreen } from '@/hooks/navigate';
import BasicButton from "@/components/basic/BasicButton";
import { Linking, Platform } from 'react-native';
import {schedulePushNotification, cancelPushNotification, createTimeIntervalTrigger} from '@/containers/Notify';
import { ScrollView } from "react-native-gesture-handler";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import ModalIcons from './ModalIcons';
import ModalImport from './ModalImport';
import { reset, setBackend, setOnline, storeTemp, updateNotify, show, setMessage } from '@/stores/mainSlice'
import {createURL} from "expo-linking";

export default function ModalAdmin({ navigation }) {
    const server = useSelector((state) => state.server ? state.server : { url: 'https://test.app.ina.coach' })
    const active = useSelector((state) => state.notify?.active || [])
    const insets = useSafeAreaInsets()

    const dispatch = useDispatch()
    const screenshots = useSelector((state) => state.temp?.screenshots || false)
    const preview = useSelector((state) => state.temp?.preview || false)
    const cloudToken = useSelector((state) => state.cloudMessaging?.token)

    const [url, setUrl] = useState(server.url)
    const [level, setLevel] = useState('logs')
    const [showModalIcons, setShowModalIcons] = useState(false)
    const [showModalImport, setShowModalImport] = useState(false)

    const setNotify = async (seconds, title, url) => {
        url = createURL('/') + url
        const data = { url: url, taskid: '7f4fa6a5-40a2-4597-828d-03316e06eeb9', step: 1 }

        const notificationId = await schedulePushNotification(
            {
                title: i18n.t('notify.title'),
                body: title,
                data: data,
                sound: "default"
            },
            createTimeIntervalTrigger(seconds)
        )
        const ntfy = {
            state: 'SET',
            ntfyId: notificationId,
            date: Date.now(),
            info: info,
            data: data,
            seconds: seconds,
        }
        dispatch(updateNotify({ notify: { active: [...active, ntfy] } }))
    }

    const cancelNotify = async (data) => {
        const entry = active.find(ntfy => Object.keys(data).every(key => ntfy.data[key] == data[key]))
        console.log('CANCEL', entry)
        if (entry) {
            await cancelPushNotification(entry.ntfyId)
            dispatch(updateNotify({ notify: { active: active.filter(ntfy => ntfy.ntfyId != entry.ntfyId) } }))
        }
    }

    return (
        <ScrollView className="bg-secondary-50" scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 70 + insets.bottom }}>
            <VStack className="m-2 py-2 items-center bg-secondary-50">
                <VStack space='sm' className="bg-secondary-50 px-2 py-2 rounded-[5px] w-[100%]">
                    <HStack space='sm'>
                        <Input variant='outline' size='lg' className="w-[75%]" >
                            <InputField autoCapitalize='none' selectionColor={"#D2D4D7"} onChangeText={setUrl} value={url} className="font-Assistant font-[700] text-secondary-900 bg-secondary-50" />
                        </Input>
                        <BasicButton flex={1} onPress={() => { dispatch(setBackend({ url: url })) }} text={i18n.t('adminModal.setServer')} />
                    </HStack>
                    <HStack space='sm'>
                        <Input variant='outline' size='lg' className="w-[75%]" >
                            <InputField autoCapitalize='none' selectionColor={"#D2D4D7"} onChangeText={setLevel} value={level} className="font-Assistant font-[700] text-secondary-900 bg-secondary-50" />
                        </Input>
                        <BasicButton flex={1} onPress={() => { dispatch(show({ level: level })) }} text={i18n.t('adminModal.showState')} />
                    </HStack>
                    {cloudToken && <Text className="text-xs text-secondary-900">{cloudToken}</Text> }
                </VStack>
                <HStack space='xs' className="bg-secondary-50 px-2 py-5">
                    <VStack space='sm' className="w-[50%]">
                        <BasicButton onPress={() => { dispatch(reset()); switchScreen(navigation, 'BACK') }} text={i18n.t('adminModal.reset')} />
                        <BasicButton onPress={() => { switchScreen(navigation, 'MainStack', {screen: 'MediaManager'}) }} text={i18n.t('adminModal.media')} />
                        <BasicButton onPress={() => { switchScreen(navigation, 'MainStack', {screen: 'Playground'}) }} text={i18n.t('adminModal.playground')} />
                        <BasicButton onPress={() => setShowModalImport(true)}  text={i18n.t('adminModal.import')} />
                        <BasicButton onPress={() => setShowModalIcons(true)}  text={i18n.t('adminModal.icons')} />
                        <BasicButton onPress={() => { dispatch(storeTemp({ temp: { screenshots: !screenshots } }))}} text={i18n.t(screenshots ? 'adminModal.shotsOff' : 'adminModal.shotsOn')} />
                        <BasicButton onPress={() => { dispatch(setOnline({status: !server.online})) }} text={i18n.t(server.online ? 'adminModal.setOffline' : 'adminModal.setOnline')} />
                        {!server.online && server.token && <BasicButton onPress={() => { dispatch(backendRequest('TOKEN_LOGIN', '/login/token', server.token.value, 'POST')) }} text={i18n.t('adminModal.tokenLogin')} />}
                        {server.online && <BasicButton onPress={() => {
                            dispatch(backendRequest('TOKEN', '/user/token', {
                                "type": "APP",
                                "description": "Login token"
                            }, 'POST'))
                        }} text={i18n.t('adminModal.tokenCreate')} />}
                        <BasicButton onPress={() => { dispatch(setMessage({msg: { level: 'warning', text: 'global.mediaSize', options: { size: 100, max: 99 }, i18n: true }})) }} text={'Message'}></BasicButton>
                    </VStack>
                    <VStack space='sm' className="w-[50%]">
                        <BasicButton onPress={() => { Sentry.captureException(new Error('Oops!')) }} text={i18n.t('adminModal.sentryTest')} />
                        <BasicButton onPress={() => { Sentry.nativeCrash() }} text={i18n.t('adminModal.sentryCrash')} />
                        <BasicButton onPress={() => { switchScreen(navigation,  'MainStack', {screen: 'ModalGame'}) }} text={i18n.t('adminModal.game')} />
                        <BasicButton onPress={() => { switchScreen(navigation,  'MainStack', {screen: 'PrintSelect'}) }} text={i18n.t('adminModal.print')} />
                        <BasicButton onPress={async () => { await setNotify(15, i18n.t('notify.news'), '/settings') }} text={i18n.t('adminModal.notify', { url: '/settings', sec: '15s' })} />
                        <BasicButton onPress={async () => { await cancelNotify({
                            taskid: '7f4fa6a5-40a2-4597-828d-03316e06eeb9',
                            step: 1
                        }) }} text={i18n.t('adminModal.notifyCancel')} />
                        <BasicButton onPress={() => {
                            try {
                                Platform.OS === 'ios' ?
                                    Linking.openURL('app-settings:') :
                                    Linking.sendIntent('android.settings.APP_NOTIFICATION_SETTINGS', [
                                        {
                                            key: 'android.provider.extra.APP_PACKAGE',
                                            value: 'de.bosconnect.inacoach',
                                        }]);
                            } catch (e) {
                                Alert.alert(e.message);
                            }

                        }} text={i18n.t('adminModal.settings')} />
                        {(server.ws?.connected || true) && <BasicButton onPress={() => { switchScreen(navigation,  'MainStack', {screen: 'Chat'}) }} text={i18n.t('adminModal.chat')} />}
                        <BasicButton onPress={() => { dispatch(storeTemp({ temp: { preview: !preview } })) }} text={i18n.t(preview ? 'adminModal.previewOff' : 'adminModal.previewOn')} />
                    </VStack>
                </HStack>
            </VStack>
            <ModalIcons showModal={showModalIcons} setShowModal={setShowModalIcons} />
            <ModalImport showModal={showModalImport} setShowModal={setShowModalImport} />
        </ScrollView>
    );
}
